import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { SIZES, Typography } from '@fupa/fupa-uikit';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import { sponsoringPartnerByDistrict } from 'app/components/partner/SiteSponsoringByDistrict';
import { sponsoringPartnerByRegion } from 'app/components/partner/SiteSponsoringByRegion';
const logoWidth = 160;
const logoHeight = 20;
const Container = styled.div.withConfig({
  componentId: "sc-1ql518l-0"
})(["display:flex;justify-content:", ";margin-bottom:", ";a{display:inherit;width:inherit;height:inherit;justify-content:inherit;}"], props => props.justify || 'left', props => props.withClaim ? 0 : SIZES['8']);
const Logo = styled.img.withConfig({
  componentId: "sc-1ql518l-1"
})(["align-self:center;max-width:", "rem;max-height:", "rem;width:100%;height:100%;"], logoWidth / 16, logoHeight / 16);
const Sponsor = styled.div.withConfig({
  componentId: "sc-1ql518l-2"
})(["display:flex;flex-wrap:nowrap;align-items:center;justify-content:flex-end;gap:0.25rem;"]);
const SCTypography = styled(Typography).withConfig({
  componentId: "sc-1ql518l-3"
})(["&&&{font-style:italic;}"]);
const SiteSponsoring = _ref => {
  var _district$region;
  let {
    className,
    withClaim
  } = _ref;
  const district = useSelector(reduxSelectDistrict);
  if (!district.slug || !(district !== null && district !== void 0 && (_district$region = district.region) !== null && _district$region !== void 0 && _district$region.slug)) {
    return null;
  }
  const partnerList = sponsoringPartnerByDistrict(district.slug) || sponsoringPartnerByRegion(district.region.slug);
  if (!partnerList) {
    return null;
  }
  const SponsorLogo = partnerList.map((partner, index) => {
    return /*#__PURE__*/React.createElement(Container, {
      key: index,
      justify: partner.justify,
      withClaim: withClaim,
      className: withClaim ? '' : className
    }, /*#__PURE__*/React.createElement("a", {
      "data-google-interstitial": "false",
      target: "_blank",
      href: partner.link,
      rel: "nofollow"
    }, /*#__PURE__*/React.createElement(Logo, {
      src: partner.imgPath,
      width: "auto",
      height: "auto",
      alt: partner.sponsor
    })));
  });
  if (withClaim) {
    return /*#__PURE__*/React.createElement(Sponsor, {
      className: className
    }, /*#__PURE__*/React.createElement(SCTypography, {
      variant: "caption1"
    }, "pr\xE4sentiert von"), SponsorLogo);
  } else {
    return SponsorLogo;
  }
};
export { SiteSponsoring };